/**
 * Counts a stat up to the value the merchant typed.
 *
 * Only the leading number is animated; any prefix or suffix ("10,000+", "%98")
 * is preserved exactly, so the final text is always what was entered. Skipped
 * entirely under reduced motion or when there is no number to count.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const DURATION = 1100;

  function parse(text) {
    // Capture prefix, the number (with thousands separators), and suffix.
    const match = text.match(/^(\D*)([\d.,]+)(.*)$/s);
    if (!match) return null;

    const raw = match[2];
    // Remember the separator style so the count-up looks like the target.
    const groupSeparator = raw.includes(',') ? ',' : raw.includes('.') ? '.' : '';
    const value = parseFloat(raw.replace(/[.,]/g, ''));
    if (!Number.isFinite(value)) return null;

    return { prefix: match[1], value, suffix: match[3], groupSeparator };
  }

  function format(value, groupSeparator) {
    const rounded = String(Math.round(value));
    if (!groupSeparator) return rounded;
    return rounded.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
  }

  function run(el) {
    const parsed = parse(el.dataset.value || el.textContent.trim());
    if (!parsed) return;

    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / DURATION, 1);
      // Ease-out so it decelerates into the final figure.
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = parsed.prefix + format(parsed.value * eased, parsed.groupSeparator) + parsed.suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        run(entry.target);
      });
    },
    { threshold: 0.4 }
  );

  function observeAll(scope) {
    scope.querySelectorAll('[data-counter]').forEach((el) => observer.observe(el));
  }

  observeAll(document);
  document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
})();
